import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TestlistService } from '@app-services/test/testlist.service';
import { navigateToDashboard } from '../congrajulations/congrajulations.component';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.css']
})
export class ThankYouComponent implements OnInit {
  navigateToDashboard = navigateToDashboard;
  routeparam:any; 
  isRepeater: any = false;
  trackierSource: any = "https://marketing.infinitylearn.com/pixel?av=612df4c302535a0b13372bab&sub1=mobile&sub2=email&sub3=first_name&sub4=last_name&sub5=exam";
  constructor(private router: Router, private testListService: TestlistService) { 
    this.routeparam = this.router.getCurrentNavigation()?.extras?.state
    if(!this.routeparam?.detailsEntered) {
      this.router.navigateByUrl('/');
      return;
    }
    this.isRepeater = this.routeparam.REPEATER;
  }
  
  ngOnInit(): void {
    if(this.isRepeater) {
      const routeparam = this.routeparam;
      this.trackierSource = `https://marketing.infinitylearn.com/pixel?av=612df4c302535a0b13372bab&sub1=${routeparam?.phone}&sub2=${routeparam?.email}&sub3=${routeparam?.firstname}&sub4=${routeparam?.lastname}&sub5=${routeparam?.exam}`;     
    }
  }
}
